<div class="empty-state">
  <p class="santa-typo-large-bold santa-mb-10">{{ translations.empty.title | translate }}</p>
  <p class="santa-typo-regular">
    {{ translations.empty.description | translate }}
    <a [routerLink]="['/']" class="santa-text-red-500">{{ translations.empty.homepage | translate }}</a
    >.
  </p>
  <img width="180" height="132" loading="eager" src="https://images.cf-rabota.com.ua/clubs/search/empty-state-illustration.svg" alt="search empty state" class="santa-mt-20" />
</div>
